import React from "react";
import { StyledContentsTitle } from './style'

export default () => {
  const title = 'Video Template Publishing Status'
  return (
    <StyledContentsTitle>{title}</StyledContentsTitle>
  )
}